<!-- HACK [attr.x] is only option to set svg parameters dynamically; syntax colouring don't work properly -->
<svg [attr.width]="size" [attr.height]="size" *ngIf="amount">
  <defs>
    <!-- HACK: mask id must be unique for each mask text -->
    <mask id="text-mask-{{ display }}" maskUnits="userSpaceOnUse">
      <rect width="100%" height="100%" fill="white" />
      <text
        x="50%"
        y="50%"
        text-anchor="middle"
        font-weight="bold"
        dominant-baseline="central"
        [attr.font-size]="amount > max ? 'x-small' : 'small'"
      >
        {{ display }}
      </text>
    </mask>
  </defs>
  <circle cx="50%" cy="50%" [attr.r]="size / 2 - 0.5" fill-rule="evenodd" [attr.mask]="'url(#text-mask-' + display + ')'"></circle>
</svg>
